export default "__VITE_ASSET__865de050__"